<template>
  
  <div class="row mb-5">
    <div class="col-48 px-xl-0 px-3 text-start my-4 d-flex flex-row justify-content-between">
    <div v-if="this.$route.query" class="fw-bold ">Your Search: <span v-if="queryRegion" class="text-capitalize text-primary px-2 queryTitle position-relative py-2">{{queryRegion}}</span><span v-if="queryName" class="text-capitalize text-primary px-2 queryTitle position-relative py-2">{{queryName}}</span> <span v-if="queryCategory" class="text-capitalize text-primary px-2 queryTitle position-relative py-2">{{queryCategory}}</span></div>
     
  </div>
  <div class="col-lg-38 col-48"> 
  <div class="row mb-3 text-start">
    <div class="col-lg-24 col-md-15 col-48 d-flex flex row align-items-center justify-content-end mb-lg-0 mb-3">
<div v-if="filteredDeals.length > 0" class="col results-total-title">{{filteredDeals.length}} <span  v-if="filteredDeals.length > 1">Results</span> <span  v-else>Result</span></div>
<div class="col primary-service text-decoration-underline d-none">Tips on how to refine your search</div>
    </div>
    <div class="col-lg-24 col-md-33 col-48 d-flex flex row align-items-center justify-content-evenly sort-by-row pe-6">
    <div class="col-auto me-5 fw-bold d-lg-block d-none">Sort By</div>
     <div class="col-lg col-12 pe-3  border-end border-primary" @click="doSort('name')">
              <div class="row w-100">
  <div class="col-24">A-Z</div><div class=" col-24 text-center d-flex flex-column align-items-start justify-content-start" v-if="sort.field=='name' && sort.desc === true"> <svg version="1.1" id="up-sort" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	     viewBox="0 0 163 102" style="enable-background:new 0 0 163 102;" xml:space="preserve" stroke-width="1px">
          <path class="st0" d="M80.9,91c-2.6,0-5.2-1-7.1-3l-62-62c-3.9-3.9-3.9-10.3,0-14.3c3.9-3.9,10.3-3.9,14.3,0l54.8,54.8l54.8-54.8
            c3.9-3.9,10.3-3.9,14.3,0c3.9,3.9,3.9,10.3,0,14.3l-62,62C86.1,90,83.5,91,80.9,91z"/>
         </svg></div> <div class=" col-24 text-center d-flex flex-column align-items-start justify-content-start" v-else><svg version="1.1" id="down-sort" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	     viewBox="0 0 163 102" style="enable-background:new 0 0 163 102;" xml:space="preserve">
          <path class="st0" d="M80.9,91c-2.6,0-5.2-1-7.1-3l-62-62c-3.9-3.9-3.9-10.3,0-14.3c3.9-3.9,10.3-3.9,14.3,0l54.8,54.8l54.8-54.8
            c3.9-3.9,10.3-3.9,14.3,0c3.9,3.9,3.9,10.3,0,14.3l-62,62C86.1,90,83.5,91,80.9,91z"/>
         </svg></div>
       </div>
          
          
          </div>
         <div class="d-md-flex d-none col-auto flex-row align-items-center justify-content-center h-100 px-2 border-end border-primary view-swap"  @click="someHandler()" >
           Quality Certified
          </div>
           <div class="col-auto ps-3 me-2">
            <div class="d-inline-flex align-items-center justify-content-center view-swap" @click.prevent="setActive('searchResultsFound')" :class="{ active: isActive('searchResultsFound') }"><img class="svg-icons-search" alt="explore-by-map" src="@/assets/list-view.png"/> <span class="
          ms-2">List View</span></div>
          </div>
         <div class="col-auto ">

             <div class="d-inline-flex align-items-center justify-content-center view-swap" @click.prevent="setActive('gogleMap')" :class="{ active: isActive('gogleMap') }" ><img class="svg-icons-search" alt="explore-by-map" src="@/assets/region.png"/> <span class="
          ms-2">Map View</span></div>
          </div>
          </div>
          
          </div>
   
  </div>
<div class="col-lg-38 col-48">
<div class="row pe-lg-6 pe-3 service-search-row border-end border-primary">
<div class="col-48">

  <div class="tab-content py-3" id="myTabContent">
      <div class="tab-pane fade show" :class="{ 'active show': isActive('searchResultsFound') }" id="searchResultsFound">
        <div v-if="filteredDeals.length === 0" class="col fs-3  text-start">
  <div class="row d-none">
    <div class="col-48">
      <p>Your search for <span class="text-capitalize "> {{queryRegion}}</span></p> 
      </div></div>
  Your search hasn't returned any results <br/>Please try modifying your search or update the filters to broaden your results.</div>

  <div  v-for="item in filteredDeals" :key="item" class="row mb-5 border border-primary category-row position-relative">
    <div class="col-lg-25 col-48  me-auto"><div class="primary-service bg-primary text-white mb-4 text-start px-3 py-2">{{item.primaryCategoryLabel}} <span v-if="item.categoriesLabel.length > 1">and more...</span></div></div>

   <div class="col-lg-25 col-48 pb-5">
     
     <div class="details service-search-details border-end border-primary ps-3 pe-lg-3 pe-5  text-start">
       <div class="title fs-4 mb-2">{{item.name}}</div>
       <div class=" fs-6 overview mb-3  fw-bold">{{item.subName}}</div>
       <div class="service-overview">{{ item.overview.split(" ").splice(0,50).join(" ")+" ..." }}</div>

       </div>
   </div>
  <div class="col-lg-23 col-48 pe-5 ps-3 pb-5">
      <router-link :to="{name: 'SingleService', params: { title: item.slug }  }"><span class="service-btn text-white"><svg version="1.1" id="serviceArrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	     viewBox="0 0 163 102" fill="white" style="enable-background:new 0 0 163 102;" xml:space="preserve">
          <path class="st0" d="M80.9,91c-2.6,0-5.2-1-7.1-3l-62-62c-3.9-3.9-3.9-10.3,0-14.3c3.9-3.9,10.3-3.9,14.3,0l54.8,54.8l54.8-54.8
            c3.9-3.9,10.3-3.9,14.3,0c3.9,3.9,3.9,10.3,0,14.3l-62,62C86.1,90,83.5,91,80.9,91z"/>
         </svg></span></router-link>
      <div class="row h-100">
        <div class="col-md-24 col-48 d-flex flex-column text-start align-items-start justify-content-center">
           <div class="address-details"> 
             <div class="address-details-street" v-if="item.street">{{item.street}}</div>
             <div class="address-details-suburb" v-if="item.suburb">{{item.suburb}}</div>
             <div class="address-details-postcode" v-if="item.state">{{item.state}}<span v-if="item.postcode"></span>, {{item.postcode}}</div>
           </div>
      <div class="s-details-connect mt-auto">
        <div class="overview mb-3">{{item.phone1}}</div>
      <div class="overview"><a target="_blank" :href="item.website">View Website <span class="screen-reader-only">(opens in a new tab)</span></a></div>
      </div>
        </div>
        <div class="col-md-24 col-48 d-md-block d-none">  <div v-if="item.image" class="service-img mb-2"><img :src="item.image"></div></div>
      </div>
     </div>
   
  </div>
      </div>
      <div class="tab-pane fade fullMap" :class="{ 'active show': isActive('gogleMap') }" id="gogleMap">    

    <GoogleMap :items="filteredDeals" />
        
</div>

    </div>


   
</div>
</div>
<div class="btn btn-primary border-0 bg-transparent text-primary px-0" @click="printWindow()"><u>Print Page</u></div>
  </div>
  
  <div class="col-10 px-3 filter-col text-start d-lg-block d-none">
    <button type="button" @click="hasHistory() 
    ? $router.go(-1) 
    : $router.push('/')" class="my-3 back-results-btn">
                    Search Again
                  </button>
   <div class="row mb-5 text-start">
<div class="fw-bold fr-title">Filter Results</div>
    </div>

    <div class="d-flex flex-column text-start mb-3">
<p>Filter Results by Keyword </p>
  <span class="w-100 filter-keyword"><input type="text" v-model="searchValue" placeholder="Enter Keyword/s"/></span>
 
  </div>
    

    <div class="d-flex flex-column text-start mb-3">
<p>Region </p>
   <select v-model="selectedStore">
    <option value="undefined" disabled selected>Please Select</option>
   <option v-for="(region, i) in regionUniq" :key="i"  :value="region">{{region}}</option>
  </select>
 
  </div>
<div class="d-flex flex-column text-start mb-3">
<p>Outreach Avaliable</p>
  <select v-model="selectedCat">
    <option value="undefined" disabled selected>Please Select</option>
    <option value="yes">Yes</option>
    <option value="no">No</option>
  </select>
 
  </div>
   <div class="d-flex flex-column text-start mb-3">
<p>Accreditation </p>
  <select v-model="selectedProduct">
    <option value="undefined" disabled selected>Please Select</option>
    <option value="yes">Quality Certified</option>
    <option value="no">No</option>
  </select>
  </div>

  </div>
  
  
  </div> 
  
</template>

<script>
 	import GoogleMap from '@/components/GoogleMap';
export default {

  props: ['items'],
   components: {
   GoogleMap,
   
  },
 data () {
      return {
        success: false,
      	 activeItem: 'searchResultsFound',
         selectedStore:null,
           selectedCat: null,
           selectedProduct: null,
    catTitle:'',
    selectedType: '',
    selectedRegion: '',
    selectedOutreach: '',
    selectedAccreditation: '',
    filteredRegion:[],
    regionUniq:[],
    updatedItems: [],
    newItems: [],
    searchValue: '',
    queryRegion:'',
    queryCategory:'',
    queryName:'',
     sort: {
        field: '',
        desc: true        
      },
       accred: {
        field: '',
        no: true        
      },
 }
 
 }, 


 mounted() {
   this.getUser()
 },

 methods:{
         printWindow: function () {		
	 window.print();
    },

     getUser () {
       if(this.$route.query){
      // console.log(this.$route.query.region)
      this.selectedStore = this.$route.query.region
      this.queryRegion = this.$route.query.region
      this.queryCategory = this.$route.query.category
       this.queryName = this.$route.query.name
    }
    
    
    },


         someHandler() {
console.log('changing')
if(this.success = !this.success) {

this.selectedProduct = 'yes'

 } else {
   
   this.selectedProduct = ''
 }
         },
      hasHistory () {
        return window.history.length > 2
      },
 	isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    doSort (field){
     this.filteredDeals.reverse()
    console.log('sort-clicked');
     if(field == this.sort.field){
        this.sort.desc = !this.sort.desc
        	 
      }else{
        this.sort.field = field;
        this.sort.desc = true;
      }
    }
 },
  computed: {
   filteredDeals(){


if(this.$route.query){
     this.items.forEach(itemRegion => {
      let filteredRegion = []
      this.filteredRegion.push(itemRegion.region)
      this.flatFilteredRegion = this.filteredRegion.flat() 
     })
     this.regionUniq = [...new Set(this.flatFilteredRegion)];
      // console.log(this.filteredDeals)
     }

         let finalFilterItems = [...this.items]
        //  console.log(finalFilterItems)
        if( this.search !='') {
        finalFilterItems =  finalFilterItems.filter(item =>
        {
          return item.name.toLowerCase().includes(this.searchValue.toLowerCase()) || item.overview.toLowerCase().includes(this.searchValue.toLowerCase())
          
        })
        }
         if(this.selectedProduct){
          //  console.log(this.selectedProduct)
               finalFilterItems =  finalFilterItems.filter((item)=>item.wanadaCertfication
                                    === this.selectedProduct)
          }
          if(this.selectedStore){
            finalFilterItems =  finalFilterItems.filter((item)=>item.region 
                                     === this.selectedStore)
          }
          if(this.selectedCat){
            // console.log(this.selectedCat)
             finalFilterItems =  finalFilterItems.filter((item)=>item.outreach 
                                     === this.selectedCat)
          }
   
          return finalFilterItems
   
      }
  },
  created(){
      //console.log('created')
  }
}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
